var _rect, _rect2, _path, _path2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "bars",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bars-left-outer-bar",
    width: 13,
    height: 23,
    x: 11.2,
    y: 38.6,
    rx: 5,
    fill: "#1422BD",
    stroke: "white",
    strokeWidth: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "bars-left-inner-bar",
    width: 6.2,
    height: 16.2,
    x: 14.7,
    y: 42,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bars-middle-bar",
    d: "M38.0595 36.269C38.0595 35.1787 37.1273 34.2797 36.0161 34.2797H33.9505C32.8389 34.2797 31.9071 35.1791 31.9071 36.269V56.1672C31.9071 57.2575 32.8393 58.1565 33.9505 58.1565H36.0161C37.1278 58.1565 38.0595 57.2571 38.0595 56.1672V36.269ZM33.9505 30.8453H36.0161C39.0932 30.8453 41.6037 33.2903 41.6037 36.269V56.1672C41.6037 59.1459 39.0932 61.5909 36.0161 61.5909H33.9505C30.8724 61.5909 28.3629 59.2005 28.3629 56.1672V36.269C28.3629 33.2903 30.8734 30.8453 33.9505 30.8453Z",
    fill: "#1422BD",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bars-arrow",
    d: "M46.6496 8.57177L46.6493 8.5722L46.66 8.57967C47.0169 8.82754 47.2298 9.22734 47.2843 9.74957L47.571 15.8206L47.5711 15.8217C47.6242 16.7976 46.8851 17.6169 45.9382 17.67H45.8274C44.9234 17.67 44.136 16.9995 44.0838 16.0837L44.0837 16.082L43.9688 14.4098L43.9428 14.0318L43.703 14.3251C32.6631 27.8281 21.1767 29.2633 16.8522 29.2633C16.3414 29.2633 15.9302 29.2358 15.6326 29.2082C15.4838 29.1944 15.3632 29.1806 15.2719 29.1702L15.2575 29.1685C15.1875 29.1605 15.1268 29.1536 15.0877 29.1521C14.1329 28.9923 13.4591 28.1173 13.615 27.209L13.4671 27.1837L13.615 27.209C13.7734 26.2852 14.674 25.6174 15.6236 25.7711L15.6235 25.7714L15.633 25.7723C15.6398 25.773 15.648 25.7738 15.6577 25.7748C16.5162 25.8612 28.8839 27.1056 41.1241 12.1181L41.352 11.839L40.9934 11.8739L39.2792 12.0407H39.1144C38.2104 12.0407 37.423 11.3702 37.3707 10.4545C37.3177 9.47733 38.0589 8.65733 39.0076 8.60625L39.0076 8.60627L39.0101 8.60609L45.3217 8.16014L45.3217 8.16019L45.3256 8.15982C45.8566 8.10838 46.2761 8.26098 46.6496 8.57177Z",
    fill: "#1422BD",
    stroke: "white",
    strokeWidth: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "bars-right-outer-bar",
    width: 13,
    height: 42.5,
    x: 45.7,
    y: 19,
    rx: 5,
    fill: "#1422BD",
    stroke: "white",
    strokeWidth: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "bars-right-inner-bar",
    width: 6.2,
    height: 35.6,
    x: 49.1,
    y: 22.6,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.4bab4ee49528fce001d1413a6d8606bc.svg";
export { ForwardRef as ReactComponent };